import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IDeleteUserRemoteAgentsParams {
  ownerId: string;
  deviceIds: string[];
}

export class DeleteUserRemoteAgentsRequest extends Request<IDeleteUserRemoteAgentsParams, IResult> {
  constructor(params: IDeleteUserRemoteAgentsParams) {
    super('deleteUserRemoteAgents', params);
  }
}
